<template>
	<core-page>
		<div class="omapi-about-us">
			<common-tabnav
				:active="currentTab"
				:tabs="allTabs"
				@go="goTo"
			/>

			<common-alerts id="om-plugin-alerts" :alerts="alerts"/>
			<about-us v-if="'about-us' === currentTab"/>
			<about-getting-started v-if="'getting-started' === currentTab"/>
			<about-lite-vs-pro v-if="'lite-pro' === currentTab"/>
		</div>
	</core-page>
</template>

<script>
import { mapState } from 'vuex'
import { tabs } from '@/pages/mixins/tabs'

export default  {
	mixins : [ tabs ],
	data () {
		return {
			pageSlug : 'about',
		}
	},
	computed : {
		...mapState([ 'error', 'alerts' ]),
	},
}
</script>

<style lang="scss">
	@import '../assets/scss/variables';
	@import '../assets/scss/pages/about';
</style>
